import { useEffect, useState } from "react";

const IS_LARGE_MOBILE_QUERY = "(max-width: 1023px)";
const IS_MOBILE_QUERY = "(max-width: 640px)";

const useIsMobile = (largeMobile = false) => {
  const [isMobile, setIsMobile] = useState(() =>
    typeof window === "undefined"
      ? false
      : window.matchMedia(largeMobile ? IS_LARGE_MOBILE_QUERY : IS_MOBILE_QUERY)
          .matches,
  );

  useEffect(() => {
    if (typeof window === "undefined") return;

    const windowMatchMedia = window.matchMedia(
      largeMobile ? IS_LARGE_MOBILE_QUERY : IS_MOBILE_QUERY,
    );
    const onChange = (e: MediaQueryListEvent) => setIsMobile(e.matches);

    // eslint-disable-next-line
    setIsMobile(windowMatchMedia.matches);

    if (typeof windowMatchMedia.addEventListener === "function") {
      windowMatchMedia.addEventListener("change", onChange);
    } else {
      windowMatchMedia.addListener(onChange);
    }

    return () => {
      if (typeof windowMatchMedia.removeEventListener === "function") {
        windowMatchMedia.removeEventListener("change", onChange);
      } else {
        windowMatchMedia.removeListener(onChange);
      }
    };
  }, [largeMobile]);

  return isMobile;
};

export { useIsMobile };
